"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceDetail = void 0;
var invoice_1 = require("./invoice");
var service_1 = require("./service");
var InvoiceDetail = /** @class */ (function () {
    function InvoiceDetail(data) {
        this.id = data.id;
        this.invoice_id = data.invoice_id;
        this.service_id = data.service_id;
        this.quantity = data.quantity * 1;
        this.price = data.price * 1;
        this.total = data.total * 1;
        if (data.invoice) {
            this.invoice = new invoice_1.Invoice(data.invoice);
        }
        if (data.service) {
            this.service = new service_1.Service(data.service);
        }
    }
    InvoiceDetail.prototype.toJson = function () {
        return __assign({}, this);
    };
    return InvoiceDetail;
}());
exports.InvoiceDetail = InvoiceDetail;
